var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shippingGroups.length
    ? _c(
        "div",
        { staticClass: "checkout-total-widget" },
        [
          _vm._l(_vm.shippingGroups, function(group, ind) {
            return _c("shipping-group-total", {
              key: group.name,
              staticClass: "checkout-total-widget__group",
              attrs: {
                index: ind,
                group: group,
                "thirdparty-store": _vm.THIRDPARTY_STORES[group.thirdPartyId]
              }
            })
          }),
          _c("div", { staticClass: "checkout-total-widget__to-pay" }, [
            _c("span", [_vm._v("Всего к оплате")]),
            _c("div", { staticClass: "checkout-total-widget__total-price" }, [
              _vm.price.old
                ? _c(
                    "span",
                    { staticClass: "checkout-total-widget__old-price" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("price")(_vm.price.old)) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _c("span", [
                _vm._v(_vm._s(_vm._f("price")(_vm.price.current)) + " ₽")
              ])
            ])
          ]),
          _c("ui-button", {
            staticClass: "checkout-total-widget__submit",
            attrs: { text: _vm.submitText, wide: "" },
            on: {
              click: function($event) {
                return _vm.$emit("submit")
              }
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }